import styled from 'styled-components';

export const Container = styled.select`
  width: 100%;
  height: 35px;
  padding: 0.375rem 0.75rem;
  font-size: 14px;
  line-height: 1.5;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  /* -webkit-appearance: none; */
`;
